import $ from 'jquery';

$(document).ready(function () {
  step7();
});

function step7() {
  let claimsDataForm = $('#claims-data-form');

  $('.info-button').on('click', function () {
    let parent = $(this).parent('.claims-data-form__item');
    let item = parent.find('.info-button');
    item.addClass('info-show');
    let text = parent.next();
    text.slideDown();
  });

  $('.i-text__close').on('click', function () {
    let parent = $(this).parent('.i-text');
    parent.slideUp();
  });

  $('#medical_payments').on('change', function () {
    let previosSumm = parseFloat($('#prev-year-summ').val().replace(/,/g, '').replace(/\s/g, '')) || 0;
    let outstanding_reserves = parseFloat($(this).val().replace(/,/g, '').replace(/\s/g, '')) || 0;

    let difference = Math.abs(previosSumm - outstanding_reserves);
    let percentageDifference = (difference / Math.max(previosSumm, outstanding_reserves || 1)) * 100;
    let finalValue = percentageDifference.toFixed(1);

    let message = 'Medical payments: Your percentage difference between the current year and last year is ' + finalValue + '%\n';
    let textAtea = $('#claims-data-form #message');

    if (finalValue >= 20) {
      textAtea.val(function (index, currentValue) {
        let newValue = currentValue.replace(/Medical payments:.*\n?/, '');
        return newValue + message;
      });
    } else {
      textAtea.val(function (index, currentValue) {
        return currentValue.replace(/Medical payments:.*\n?/, '');
      });
    }
  });

  $('#indemnity_payments').on('change', function () {
    let previosSumm = parseFloat($('#prev-year-summ-1').val().replace(/,/g, '').replace(/\s/g, '')) || 0;
    let outstanding_reserves = parseFloat($(this).val().replace(/,/g, '').replace(/\s/g, '')) || 0;

    let difference = Math.abs(previosSumm - outstanding_reserves);
    let percentageDifference = (difference / Math.max(previosSumm, outstanding_reserves || 1)) * 100;
    let finalValue = percentageDifference.toFixed(1);


    let message = 'Indemnity payments: Your percentage difference between the current year and last year is ' + finalValue + '%\n';
    let textAtea = $('#claims-data-form #message');

    if (finalValue >= 20) {
      textAtea.val(function (index, currentValue) {
        let newValue = currentValue.replace(/Indemnity payments:.*\n?/, '');
        return newValue + message;
      });
    } else {
      textAtea.val(function (index, currentValue) {
        return currentValue.replace(/Indemnity payments:.*\n?/, '');
      });
    }
  });
  $('#outstanding_reserves').on('change', function () {
    let previosSumm = parseFloat($('#prev-year-summ-2').val().replace(/,/g, '').replace(/\s/g, '')) || 0;
    let outstanding_reserves = parseFloat($(this).val().replace(/,/g, '').replace(/\s/g, '')) || 0;

    let difference = Math.abs(previosSumm - outstanding_reserves);
    let percentageDifference = (difference / Math.max(previosSumm, outstanding_reserves || 1)) * 100;
    let finalValue = percentageDifference.toFixed(1);

    let message = 'Outstanding reserves: Your percentage difference between the current year and last year is ' + finalValue + '%\n';
    let textAtea = $('#claims-data-form #message');

    if (finalValue >= 20) {
      textAtea.val(function (index, currentValue) {
        let newValue = currentValue.replace(/Outstanding reserves:.*\n?/, '');
        return newValue + message;
      });
    } else {
      textAtea.val(function (index, currentValue) {
        return currentValue.replace(/Outstanding reserves:.*\n?/, '');
      });
    }
  });

  function updateMessage(fieldId, prevYearId, messagePrefix) {
    let previosSumm = parseFloat($(prevYearId).val().replace(/,/g, '').replace(/\s/g, '')) || 0;
    let outstanding_reserves = parseFloat($(fieldId).val().replace(/,/g, '').replace(/\s/g, '')) || 0;

    let difference = Math.abs(previosSumm - outstanding_reserves);
    // let percentageDifference = (difference / Math.max(previosSumm, outstanding_reserves || 1)) * 100;
    let percentageDifference = (difference / (previosSumm || 1)) * 100;
    let finalValue = percentageDifference.toFixed(1);

    let message = `${messagePrefix}: Your percentage difference between the current year and last year is ${finalValue}%\n`;
    let textArea = $('#claims-data-form #message');

    textArea.val(function (index, currentValue) {
      let regex = new RegExp(`^${messagePrefix}:.*\n?`, 'm');
      let newValue = currentValue;

      if (regex.test(currentValue)) {
        newValue = currentValue.replace(regex, message);
      } else {
        newValue = currentValue + (currentValue.endsWith('\n') || currentValue === '' ? '' : '\n') + message;
      }

      return newValue.trim() + '\n';
    });
  }

// Attach event listeners to inputs
  $('#medical_payments').on('input change', function () {
    updateMessage('#medical_payments', '#prev-year-summ', 'Medical payments');
  });

  $('#indemnity_payments').on('input change', function () {
    updateMessage('#indemnity_payments', '#prev-year-summ-1', 'Indemnity payments');
  });

  $('#outstanding_reserves').on('input change', function () {
    updateMessage('#outstanding_reserves', '#prev-year-summ-2', 'Outstanding reserves');
  });


  // $(document).ready(function () {
  //   if ($('#medical_payments').val()) {
  //     updateMessage('#medical_payments', '#prev-year-summ', 'Medical payments');
  //   }
  //   if ($('#indemnity_payments').val()) {
  //     updateMessage('#indemnity_payments', '#prev-year-summ-1', 'Indemnity payments');
  //   }
  //   if ($('#outstanding_reserves').val()) {
  //     updateMessage('#outstanding_reserves', '#prev-year-summ-2', 'Outstanding reserves');
  //   }
  // });

  //comment submit
  var rejectFormButton = $('#step-7-reject-form');
  var commentForm = $('#comment-7-step-form');

  $('#step-7-reject-form').on('submit', function (el) {
    let comment = commentForm.find('textarea').val();
    let hiddenComment = rejectFormButton.find('.hidden-comment').val(comment);
  });

  $('#step-7-submit').on('click', function (el) {
    el.preventDefault();
    let s7link = $(this).attr('href');

    let formArray = [];

    function objectifyForm(formArray) {
      //serialize data function
      var returnArray = {};
      for (var i = 0; i < formArray.length; i++) {
        returnArray[formArray[i]['name']] = formArray[i]['value'];
      }
      return returnArray;
    }

    let form = document.querySelector('#claims-data-form');
    let data = objectifyForm(form);
    formArray.push(data);
    formArray = JSON.stringify(formArray);
    console.log(formArray);
    var formData = new FormData();

    formData.append('action', 'claims_data');
    formData.append('claims_data_data', formArray);
    fetch(ajax_object.ajax_url, {
      method: 'POST',
      body: formData,
    })
      .then((res) => res.text())
      .then((data) => {
        window.location.href = s7link;
      })
      .catch((err) => console.log(err));
  });

  $('.step-7-next').on('click', function (el) {
    el.preventDefault();

    let s7link = $(this).attr('href');

    let formArray = [];

    function objectifyForm(formArray) {
      //serialize data function
      var returnArray = {};
      for (var i = 0; i < formArray.length; i++) {
        returnArray[formArray[i]['name']] = formArray[i]['value'];
      }
      return returnArray;
    }

    let form = document.querySelector('#claims-data-form');
    let data = objectifyForm(form);
    formArray.push(data);
    formArray = JSON.stringify(formArray);
    console.log(formArray);
    var formData = new FormData();

    formData.append('action', 'claims_data');
    formData.append('claims_data_data', formArray);
    fetch(ajax_object.ajax_url, {
      method: 'POST',
      body: formData,
    })
      .then((res) => res.text())
      .then((data) => {
        window.location.href = s7link;
      })
      .catch((err) => console.log(err));
  });
}
